import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { agrogestao } from '@/api/agrogestaoClient';
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { FaturasAdmin } from "@/pages/admin/components/FaturasAdmin";

export function FinanceiroAdmin({ selectedPropId }) {
    const [refresh, setRefresh] = useState(0);

    const { data: pixWebhookLogs = [] } = useQuery({
        queryKey: ['pix_webhook_logs', refresh],
        queryFn: async () => {
            try {
                const { data, error } = await agrogestao.client
                    .from('audit_logs')
                    .select('created_at, user_email, acao, status, details')
                    .or('acao.ilike.%pix%,acao.ilike.%abacate%')
                    .order('created_at', { ascending: false })
                    .limit(50);
                if (error) return [];
                return data || [];
            } catch { return []; }
        }
    });

    const executarDunning = async () => {
        try {
            const { data } = await agrogestao.functions.invoke('executarDunningFaturas', {});
            if (data?.success === false) throw new Error(data?.error || 'erro');
            setRefresh(x => x + 1);
            alert('Dunning executado com sucesso');
        } catch (e) {
            alert('Falha ao executar dunning');
        }
    };

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2">
                <Button onClick={executarDunning} className="bg-indigo-600 hover:bg-indigo-700">Executar dunning agora</Button>
            </div>

            <FaturasAdmin selectedPropId={selectedPropId} refresh={refresh} onRefresh={() => setRefresh(x => x + 1)} />

            <div className="space-y-2 mt-6 p-4 bg-stone-50 rounded border">
                <div className="text-sm font-medium">Logs de Webhook (AbacatePay)</div>
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b">
                                <th className="text-left py-3 px-4">Data</th>
                                <th className="text-left py-3 px-4">Ação</th>
                                <th className="text-left py-3 px-4">Status</th>
                                <th className="text-left py-3 px-4">Detalhes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pixWebhookLogs.length === 0 ? (
                                <tr><td colSpan={4} className="py-6 text-center text-stone-500">Sem logs</td></tr>
                            ) : pixWebhookLogs.map((l, idx) => (
                                <tr key={idx} className="border-b">
                                    <td className="py-3 px-4">{l.created_at ? format(new Date(l.created_at), 'dd/MM/yyyy HH:mm') : '-'}</td>
                                    <td className="py-3 px-4">{l.acao || '-'}</td>
                                    <td className="py-3 px-4">{l.status || '-'}</td>
                                    <td className="py-3 px-4 text-xs break-all max-w-[300px]">{typeof l?.details === 'string' ? l.details : JSON.stringify(l?.details || {})}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
